module.exports = __webpack_public_path__ + "img/news_02.03763249.jpg";